import type { QueryClient } from '@tanstack/react-query';

import { getCodingListsEntriesQuery, getCodingListsQuery } from '../../../queries/codingQuery';
import { allTeamsQuery, teamsQuery } from '../../../queries/teamQuery';
import { userQuery } from '../../../queries/userQuery';

export const settingsCodingLoader = async ({ queryClient }: { queryClient: QueryClient }) => {
	const user = await queryClient.ensureQueryData(userQuery);

	const codingLists = await queryClient.ensureQueryData(getCodingListsQuery({ skipDisabled: false }));

	const codingEntries = await queryClient.ensureQueryData(
		getCodingListsEntriesQuery({
			codingLists,
		}),
	);

	return {
		user,
		teams: await queryClient.ensureQueryData(teamsQuery({ state: 'active' })),
		allTeams: await queryClient.ensureQueryData(allTeamsQuery),
		codingLists,
		codingEntries,
	};
};
